import { makeAutoObservable } from "mobx";
import Perfil from '../api/perfil/perfil';

export class PerfilStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  entities = [];

  getAll = async () => {
    this.loading = true;
    try {
      const result = await Perfil.getAll();
      if (result.success) this.entities = result.data;
      return Promise.resolve(true)
    } catch (error) {
      // Alertas
      return Promise.resolve(false)
    } finally {
      this.loading = false;
    }
  };  
}
